/* SHOW WHAT YOU TYPED.

   A long password on a phone keyboard is the difference between signing in and giving
   up, and every password field in this product was write-only. One file, registered as a
   web include, so it reaches the console sign-in, the recovery and first-time screens,
   the account page AND the client-side login without any of them being edited -- a field
   added next month gets it too.

   HIDDEN BY DEFAULT, always. Revealing is a deliberate act by the person holding the
   phone; nothing here ever starts revealed, and nothing is remembered between loads. */
(function () {
  var MARK = "lcEye";
  function deco(inp) {
    if (!inp || inp.dataset[MARK]) return;
    if (inp.type !== "password") return;
    if (inp.closest("[data-no-eye]")) return;
    // A PAGE THAT ALREADY HAS ONE DOES NOT GET A SECOND. Three pages had written their
    // own reveal before this existed, and the result was a Show label and an eye sitting
    // on top of each other. Those three are gone, but the guard stays: the next person to
    // add a toggle by hand gets one control, not two.
    //
    // ⚠️ BUT OUR OWN EYE MUST NOT VETO A SIBLING FIELD. This used to ask the parent for ANY
    // matching button, and after the first field was wrapped our own eye -- aria-label "Show
    // password" -- was a descendant of that same parent. So a container holding two password
    // boxes only ever got ONE eye, on the first: the setup page's "Repeat it" had none, which
    // is exactly what was reported. Skip buttons that live inside a wrap we made.
    var near = inp.parentNode;
    if (near) {
      var pre = near.querySelectorAll(
          'button[aria-label*="password" i], .lg-eye, .peek, .pc-reveal');
      for (var pi = 0; pi < pre.length; pi++) {
        if (!pre[pi].closest(".lc-eye-wrap")) return;
      }
    }
    inp.dataset[MARK] = "1";
    var wrap = document.createElement("span");
    wrap.className = "lc-eye-wrap";
    inp.parentNode.insertBefore(wrap, inp);
    wrap.appendChild(inp);
    var b = document.createElement("button");
    b.type = "button";
    b.className = "lc-eye";
    b.setAttribute("aria-label", "Show password");
    b.setAttribute("tabindex", "-1");
    b.innerHTML = eyeSvg(false);
    b.addEventListener("click", function (ev) {
      ev.preventDefault();
      var on = inp.type === "password";
      inp.type = on ? "text" : "password";
      b.innerHTML = eyeSvg(on);
      b.setAttribute("aria-label", on ? "Hide password" : "Show password");
      try { inp.focus(); } catch (e) {}
    });
    wrap.appendChild(b);
  }
  function eyeSvg(open) {
    return open
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
        + ' width="18" height="18"><path d="M3 3l18 18"/><path d="M10.6 10.6a2 2 0 002.8'
        + ' 2.8"/><path d="M9.4 5.2A9.6 9.6 0 0112 5c5 0 9 4.5 9 7a11 11 0 01-2.4 3.3M6.2'
        + ' 6.7A11.7 11.7 0 003 12c0 2.5 4 7 9 7a9.6 9.6 0 003.3-.6"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
        + ' width="18" height="18"><path d="M1.5 12S5.5 5 12 5s10.5 7 10.5 7-4 7-10.5'
        + ' 7S1.5 12 1.5 12z"/><circle cx="12" cy="12" r="3"/></svg>';
  }
  function sweep(root) {
    try {
      var l = (root || document).querySelectorAll('input[type="password"]');
      for (var i = 0; i < l.length; i++) deco(l[i]);
    } catch (e) {}
  }
  function boot() {
    sweep(document);
    // Fields that arrive later -- a dialog, a step of a wizard -- get one too.
    try {
      new MutationObserver(function () { sweep(document); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();
